export const parseDate = (data: string) => new Date(data);

export const parseDateOrUndefined = (data: string | undefined) => (data ? parseDate(data) : undefined);
export const fromDateToString = (data: Date): string => data.toISOString();
